import { MouseSensor as LibMouseSensor } from "@dnd-kit/core";
import type { MouseEvent } from "react";

/**
 * Determines whether a drag event should be handled based on the element tree.
 *
 * Dragging is disabled if the target or any parent element has `data-no-dnd`.
 * @param {HTMLElement | null} element - The HTML element that triggered the event
 * @returns {boolean} `true` if the event should be handled, otherwise `false`
 */
function shouldHandleEvent(element: HTMLElement | null): boolean {
  let cur = element;

  while (cur) {
    if (cur.dataset && cur.dataset.noDnd) {
      return false;
    }
    cur = cur.parentElement;
  }

  return true;
}

export class CMouseSensor extends LibMouseSensor {
  static activators = [
    {
      eventName: "onMouseDown" as const,
      handler: ({ nativeEvent: event }: MouseEvent): boolean => {
        return shouldHandleEvent(event.target as HTMLElement);
      },
    },
  ];
}
